import { IBadgeData } from './types';
import { v4 as uuidv4 } from 'uuid';

export default class BadgeFactory {
  static Create(): IBadgeData {
    return {
      app: 'VisIT',
      id: uuidv4(),
    };
  }
}
